// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"table-2"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M2.5 4.5H21.5V19.5H2.5V4.5Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 4.5V19.5M21.5 9.5H2.5M21.5 14.5H2.5M2.5 4.5H21.5V19.5H2.5V4.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Table2Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'table-2',
    ref,
    icon: element,
  },
));

Table2Icon.displayName = 'Table2Icon';

export default Table2Icon;
